<template>

</template>
<script type="text/javascript">
// 定义一些公共的属性和方法
const httpUrl = 'https://geo-api.niushi.cc/report'
// 暴露出这些属性
export default {
  httpUrl,
}
</script>



// WEBPACK FOOTER //
// src/components/global.vue